import { InputHTMLAttributes, LabelHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes, forwardRef } from 'react';

export const Label = ({ className = '', ...props }: LabelHTMLAttributes<HTMLLabelElement>) => (
  <label className={`block text-sm font-medium text-ink mb-1.5 ${className}`} {...props} />
);

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className = '', error, ...props }, ref) => (
  <div>
    <input
      ref={ref}
      className={`w-full rounded border px-3.5 py-2.5 text-ink bg-white placeholder:text-ink/40 transition-colors ${
        error ? 'border-red-400' : 'border-line focus:border-seal-blue'
      } ${className}`}
      {...props}
    />
    {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
  </div>
));
Input.displayName = 'Input';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className = '', error, ...props }, ref) => (
  <div>
    <textarea
      ref={ref}
      className={`w-full rounded border px-3.5 py-2.5 text-ink bg-white placeholder:text-ink/40 transition-colors ${
        error ? 'border-red-400' : 'border-line focus:border-seal-blue'
      } ${className}`}
      {...props}
    />
    {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
  </div>
));
Textarea.displayName = 'Textarea';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(({ className = '', error, children, ...props }, ref) => (
  <div>
    <select
      ref={ref}
      className={`w-full rounded border px-3.5 py-2.5 text-ink bg-white transition-colors ${
        error ? 'border-red-400' : 'border-line focus:border-seal-blue'
      } ${className}`}
      {...props}
    >
      {children}
    </select>
    {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
  </div>
));
Select.displayName = 'Select';
